export enum API_ERROR_CODES {
  REQUEST_OK = 200,
  REQUEST_BAD = 400,
  REQUEST_SERVER_ERROR = 500,
  RESPONSE_EMPTY = 204,
}
